import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Auth Interceptor (web / HttpOnly cookie)
 *
 * - Ustawia withCredentials na każdym żądaniu (przeglądarka wysyła HttpOnly cookies z JWT).
 * - Dodaje nagłówek X-Client-Type: web, żeby backend wiedział jak zwrócić tokeny.
 * - Dodaje X-CSRF-Token (z cookie `csrf_token`) do mutacji (POST/PUT/PATCH/DELETE).
 *
 * Nie dodaje Authorization: Bearer — access token jest w HttpOnly cookie,
 * JS nie ma do niego dostępu i nie musi.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private static readonly MUTATION_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const setHeaders: Record<string, string> = {
      'X-Client-Type': 'web',
    };

    if (AuthInterceptor.MUTATION_METHODS.has(request.method.toUpperCase())) {
      const csrf = this.getCookie('csrf_token');
      if (csrf) {
        setHeaders['X-CSRF-Token'] = csrf;
      }
    }

    const modified = request.clone({
      setHeaders,
      withCredentials: true,
    });

    return next.handle(modified);
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
}
